// src/components/Footer.js
import React from 'react';
import { motion } from 'framer-motion';

function Footer() {
  // Check if we're on mobile
  const isMobile = typeof window !== 'undefined' ? window.innerWidth <= 768 : false;

  return (
    <>
      {/* BOTTOM CTA SECTION - 100% WIDTH (Fade & slide-up on scroll) */}
      <motion.section
        style={styles.bottomSection}
        initial={{ y: 40, opacity: 0 }}
        whileInView={{ y: 0, opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.7 }}
      >
        <div style={styles.bottomOverlay}>
          <h2 style={isMobile ? styles.bottomHeadingMobile : styles.bottomHeading}>
            HL'ADÁTE PRENÁJOM BYTU ALEBO AUTOMOBILU ?
          </h2>
          <p style={isMobile ? styles.bottomTextMobile : styles.bottomText}>
            Hľadáte nový nájom? Chcete si požičať auto? Vyberte si z našej ponuky
            a staňte sa naším spokojným klientom.
            <br />
            Ak hľadáte bývanie, tak ste na správnom mieste. Obráťte sa na nás.
          </p>
          <button style={isMobile ? styles.bottomButtonMobile : styles.bottomButton}>Ponuka nehnuteľností</button>
        </div>
      </motion.section>
    </>
  );
}

export default Footer;

const styles = {
  // BOTTOM CTA SECTION
  bottomSection: {
    position: 'relative',
    width: '100%',
    minHeight: '60vh',
    // Add top margin so there's space before this section
    marginTop: '3rem',
    backgroundImage: `url('https://www.eurocentrumprievidza.sk/wp-content/uploads/2024/02/Kitchen.jpg')`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    marginBottom: '2rem',
  },
  bottomOverlay: {
    width: '100%',
    minHeight: '60vh',
    // Gradient with no white and a darker tone
    background: `
     linear-gradient(
        45deg,
        rgb(44, 105, 160) 0%,
        rgb(100, 90, 255) 100%
      )
    `,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#fff',
    textAlign: 'center',
    padding: '3rem 2rem',
  },
  bottomHeading: {
    fontSize: '3rem',
    fontWeight: '700',
    marginBottom: '1rem',
  },
  bottomHeadingMobile: {
    fontSize: '2rem',
    fontWeight: '700',
    marginBottom: '1rem',
  },
  bottomText: {
    fontSize: '1.2rem',
    lineHeight: 1.6,
    marginBottom: '2rem',
    maxWidth: '700px',
  },
  bottomTextMobile: {
    fontSize: '0.9rem',
    lineHeight: 1.5,
    marginBottom: '1.5rem',
    maxWidth: '100%',
    padding: '0 10px',
  },
  // Button color changed to match the gradient palette
  bottomButton: {
    fontSize: '1.2rem',
    padding: '1rem 2rem',
    backgroundColor: 'white',
    color: 'black',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
    transition: 'opacity 0.3s ease',
  },
  bottomButtonMobile: {
    fontSize: '0.9rem',
    padding: '0.8rem 1.5rem',
    backgroundColor: 'white',
    color: 'black',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
    transition: 'opacity 0.3s ease',
  },
};
